export const enum Counterparty {
    Corona = "Corona Energy",
    Macquarie = "Macquarie"
};